module.exports = __webpack_public_path__ + "static/media/kegstar-icon.23571b93.png";